import { TABS } from '../RequestFields';

export const DEFAULT_INITIAL_TABS = {
  GET: TABS.PARAMS,
  DELETE: TABS.PARAMS,
  HEAD: TABS.PARAMS,
  PUT: TABS.BODY,
  POST: TABS.BODY,
  PATCH: TABS.BODY,
};
